@if(RoutePage === navigation.Map) {
<div id="mapLeaflet-wrapper">
  <as-split direction="vertical" [useTransition]="true">
    <as-split-area order="1" size="100" [visible]="true">
      <as-split (dragEnd)="onSplitDragEnd()" direction="vertical" [useTransition]="true">
        <as-split-area
          order="1"
          [size]="70"
          [visible]="sectionVisible === 0 || sectionVisible === 1"
          style="padding-top: 0.8%"
        >
          <div class="map-kpi-container">
            <app-route-panel
              [kpiData]="kpiData"
              [selectedView]="selectedView"
              [isTableCollapsed]="isTableCollapsed"
              [selectedKPIRoutes]="selectedKPIRoutes"
              [loading]="loading"
              (selectViewEvent)="selectView($event)"
              (toggleTableEvent)="toggleTable()"
              (routeSelectEvent)="routeSelect($event)"
              (deselectAllEvent)="deselectAll()"
              (focusDriverMarkerOnMapEvent)="focusDriverMarkerOnMap($event)"
            ></app-route-panel>
            <!--Expande route table icon-->
            <ng-container *ngIf="isTableCollapsed">
              <div
                class="collapse-toggle collapsed-btn fixed-expand-btn"
                (click)="toggleTable()"
                [pTooltip]="'expand'"
              >
                <i class="pi pi-angle-right"></i>
              </div>
            </ng-container>
            <div
              class="map-container"
              [ngClass]="{ 'full-width': isTableCollapsed }"
            >
              <div [id]="mapID" class="map"></div>
            </div>
          </div>
        </as-split-area>
        <as-split-area
          order="2"
          [size]="30"
          [visible]="sectionVisible === 0 || sectionVisible === 2"
        >
          <app-task-bank class="w-100 h-100"></app-task-bank>
        </as-split-area>
      </as-split>
    </as-split-area>
  </as-split>
</div>
} 
@if(RoutePage === navigation.Landing) {
<div id="mapLeaflet-wrapper">
  <as-split (dragEnd)="onSplitDragEnd()" direction="vertical" size="100" [useTransition]="true">
    <as-split-area
      order="1"
      [size]="topRegionPaneSize()"
      [visible]="sectionVisible === 0 || sectionVisible === 1"
    >
      <as-split direction="horizontal" size="100">
        <as-split-area order="3" [size]="routeListPaneSize() + ganttPaneSize()">
          <app-route-list
              [kpiData]="kpiData"
              [selectedKPIRoutes]="selectedKPIRoutes"
              [loading]="loading"
              [isSelectionEnable]="true"
              (routeSelectEvent)="routeSelect($event)"
              (deselectAllEvent)="deselectAll()"
              (focusDriverMarkerOnMapEvent)="focusDriverMarkerOnMap($event)"
          ></app-route-list>
        </as-split-area>
        <as-split-area order="4" [visible]="mapPaneVisible()" [size]="mapPaneSize()" style="height: 100%; display: flex; flex-direction: column;">
          <div class="homepage-map-container">
            <div id="map-header-section" class="map-header-section">
              <div class="header-title">
                <p class="px-1">Map</p>
              </div>
              <div class="d-flex align-items-center mt-1 px-1">
                <p-select [options]="viewOptions" [ngModel]="selectedView" [style]="{height:'30px'}" (onChange)="selectView($event)">
                </p-select>
              </div>
            </div>
            <div [id]="mapID" class="map "></div>
          </div>
        </as-split-area>
      </as-split>
    </as-split-area>
    <as-split-area
      order="2"
      [size]="taskBankPaneSize()"
      [visible]="sectionVisible === 0 || sectionVisible === 2"
    >
      <app-task-bank class="w-100 h-100"></app-task-bank>
    </as-split-area>
  </as-split>
</div>
}
